import React from 'react';
import { Box } from '@chakra-ui/react';
import PropTypes from 'prop-types';

function Text({ size = 'large', children, ...rest }) {
  const sizes = {
    large: {
      fontSize: { base: 'sm', md: 'md' },
      lineHeight: { base: 1.429, md: 1.5 },
    },
    medium: {
      fontSize: { base: 'xs', md: 'sm' },
      lineHeight: 1.429,
    },
    small: {
      fontSize: { base: '2xs', md: 'xs' },
      lineHeight: { base: 1.273, md: 1.333 },
    },
  };
  const selected = sizes[size];

  return (
    <Box as="p" {...selected} {...rest}>
      {children}
    </Box>
  );
}

Text.propTypes = {
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  children: PropTypes.node.isRequired,
};

export default Text;
